// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'fb5acb2e-b829-401a-b42a-37ac33830a65',
      type: 'NineSlicePlane',
      name: 'beigeBackground',
      className: '',
      x: -318,
      y: -203,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 636,
      height: 406,
      leftWidth: 48,
      topHeight: 68,
      rightWidth: 48,
      bottomHeight: 48,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'PopUp_Darker_Field_With_Text_Field_9Slice_48x68x48x48',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          visible: false
        }
      }
    },
    {
      id: '7585cbe3-83d4-4f1c-a8cf-5516d944c68a',
      type: 'NineSlicePlane',
      name: 'beigeBackgroundSmall',
      className: '',
      x: -318,
      y: -203,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 636,
      height: 326,
      leftWidth: 48,
      topHeight: 68,
      rightWidth: 48,
      bottomHeight: 48,
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'PopUp_Darker_Field_With_Text_Field_9Slice_48x68x48x48',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          visible: true
        }
      }
    },
    {
      id: 'af234ba6-ef1a-4f0a-9539-b10c4ad53b95',
      type: 'Text',
      name: 'collectText',
      className: '',
      x: 0,
      y: -164,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Still need to collect',
      localize: true,
      maxWidth: 600,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#8f2c2b',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          y: -163
        }
      }
    },
    {
      id: '11480626-3ecd-47c7-902c-549cc75185de',
      type: 'Text',
      name: 'restartDescriptionText',
      className: '',
      x: 0,
      y: -164,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'You’ll have to restart the level!',
      localize: true,
      maxWidth: 600,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#8f2c2b',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          y: -163
        }
      }
    },
    {
      id: 'ed108b95-5509-4e34-ad5a-d8278dd3eb32',
      type: 'Container',
      name: 'tasksSlot',
      className: '',
      x: 0,
      y: 27,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          y: -10
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'watchAd'
  ],
  animations: [
    {
      id: 'eed4ce76-d903-453a-bfcc-032d7e71ede6',
      name: 'switchToAreYouSure_UnlimitedLives',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '9f03a517-9082-4744-b0ea-7bdfb7543b0e',
          type: 'Tween',
          name: 'setCollectTextAlpha_0',
          duration: 150,
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'collectText',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '045ca1b1-0037-485f-a80a-56dfa78882ba',
          type: 'Tween',
          name: 'setRestartTextAlpha_0',
          duration: 300,
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 100,
          sourceName: 'restartDescriptionText',
          easing: 'SinusoidalIn',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class OutOfSpaceProgressLayout {
  static raw = raw;
  root!: Container;
  beigeBackground!: NineSlicePlane;
  beigeBackgroundSmall!: NineSlicePlane;
  collectText!: Text;
  restartDescriptionText!: Text;
  tasksSlot!: Container;
  StateName!: 'watchAd';

  constructor() {
    populate(this, raw);
  }
}

export abstract class switchToAreYouSure_UnlimitedLives {
  Layout: {
    collectText: object;
    restartDescriptionText: object;
  };

  BlockTypeByName: {
    setCollectTextAlpha_0: object;
    setRestartTextAlpha_0: object;
  };

  flowData = raw.animations[0];
}
